import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import VideoPage from "../pages/video/page";
import SearchPage from "../pages/search/page";
import UploadPage from "../pages/upload/page";
import ProfilePage from "../pages/profile/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <CategoryPage /> },
      { path: "video/:id", element: <VideoPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "upload", element: <UploadPage /> },
      { path: "profile", element: <ProfilePage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;